const BAKER_WEB_COMPONENT_MODULE = 'ps-baker-webcomponent-module';

/**
 *
 * @param {typeof import('svelte').SvelteComponent} Component
 * @param {HTMLElement} target
 * @param {Record<string, any>} props
 * @param {boolean} hydrate
 * @param {import('svelte').Component}
 */
export function renderSvelteComponent(
  Component,
  target,
  props = {},
  hydrate = false
) {
  return new Component({ target, props, hydrate });
}

/**
 * @param {string} selector
 * @returns {HTMLElement|null}
 */
export const findElementInShadowDom = (selector) => {
  const element = document.querySelector(selector);
  // @ts-ignore
  if (element) return element;

  // Check for Baker embeds
  for (const element of Array.from(
    document.querySelectorAll(BAKER_WEB_COMPONENT_MODULE)
  )) {
    const match = element.shadowRoot?.querySelector(selector);
    if (match) {
      // @ts-ignore
      return match;
    }
  }

  return null;
};

/**
 * @param {string} id
 * @returns {HTMLElement|null}
 */
export const findElementByIdInShadowDom = (id) => {
  const element = document.getElementById(id);
  // @ts-ignore
  if (element) return element;

  // Check for Baker embeds
  for (const element of Array.from(
    document.querySelectorAll(BAKER_WEB_COMPONENT_MODULE)
  )) {
    const match = element.shadowRoot?.getElementById(id);
    if (match) {
      // @ts-ignore
      return match;
    }
  }

  return null;
};

/**
 * @param {string} selector
 * @returns {NodeListOf<Element>|null}
 */
export const findAllElementsInShadowDom = (selector) => {
  const elements = document.querySelectorAll(selector);
  if (elements.length) return elements;

  // Check for Baker embeds
  for (const element of Array.from(
    document.querySelectorAll(BAKER_WEB_COMPONENT_MODULE)
  )) {
    const matches = element.shadowRoot?.querySelectorAll(selector);
    if (matches && matches.length) {
      return matches;
    }
  }

  return null;
};
